import { appConfig } from '../../../config/config.app';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export type ForgotPasswordRequest = {
  username: string;
};
export const requestForgotPassword = async (requestBody: ForgotPasswordRequest, aroIdMeStepUpEnabled = false) => {
  try {
    const result = await post(
      '/guest/forgotPassword',
      { body: JSON.stringify(requestBody) },
      appConfig.apiUrl,
      true,
      true,
      false,
      aroIdMeStepUpEnabled,
    );

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
